var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_11699",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 76
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "#004DDD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_11699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3333 47.4999C45.2306 47.4999 46.009 47.1701 46.6688 46.5103C47.3285 45.8506 47.6583 45.0721 47.6583 44.1749C47.6583 43.2777 47.3285 42.4992 46.6688 41.8395C46.009 41.1798 45.2306 40.8499 44.3333 40.8499C43.4361 40.8499 42.6576 41.1798 41.9979 41.8395C41.3382 42.4992 41.0083 43.2777 41.0083 44.1749C41.0083 45.0721 41.3382 45.8506 41.9979 46.5103C42.6576 47.1701 43.4361 47.4999 44.3333 47.4999ZM41.9583 37.3666H46.7083C46.7083 35.836 46.8667 34.7145 47.1833 34.002C47.5 33.2895 48.2389 32.3527 49.4 31.1916C50.9833 29.6082 52.0389 28.3284 52.5667 27.352C53.0945 26.3756 53.3583 25.2277 53.3583 23.9083C53.3583 21.5333 52.5271 19.5937 50.8646 18.0895C49.2021 16.5853 47.025 15.8333 44.3333 15.8333C42.1695 15.8333 40.2826 16.4402 38.6729 17.6541C37.0632 18.868 35.9417 20.4777 35.3083 22.4833L39.5833 24.2249C40.0583 22.9055 40.7049 21.9159 41.5229 21.2562C42.341 20.5964 43.2778 20.2666 44.3333 20.2666C45.6 20.2666 46.6292 20.6228 47.4208 21.3353C48.2125 22.0478 48.6083 23.011 48.6083 24.2249C48.6083 24.9638 48.3972 25.6631 47.975 26.3228C47.5528 26.9826 46.8139 27.8138 45.7583 28.8166C44.0167 30.3471 42.9479 31.5478 42.5521 32.4187C42.1563 33.2895 41.9583 34.9388 41.9583 37.3666ZM25.3333 56.9999C23.5917 56.9999 22.1007 56.3798 20.8604 55.1395C19.6201 53.8992 19 52.4082 19 50.6666V12.6666C19 10.9249 19.6201 9.43395 20.8604 8.19367C22.1007 6.95339 23.5917 6.33325 25.3333 6.33325H63.3333C65.075 6.33325 66.566 6.95339 67.8063 8.19367C69.0465 9.43395 69.6667 10.9249 69.6667 12.6666V50.6666C69.6667 52.4082 69.0465 53.8992 67.8063 55.1395C66.566 56.3798 65.075 56.9999 63.3333 56.9999H25.3333ZM12.6667 69.6666C10.925 69.6666 9.43404 69.0464 8.19376 67.8062C6.95348 66.5659 6.33334 65.0749 6.33334 63.3332V18.9999H12.6667V63.3332H57V69.6666H12.6667Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizDark);
export default __webpack_public_path__ + "static/media/quiz_dark.68954c65324bfacbad3e693aaaccd236.svg";
export { ForwardRef as ReactComponent };